import React from "react";
import "./Business.css";
import Business1 from '../../assets/images/business1.png';
import Business2 from '../../assets/images/business2.png';
import Business3 from '../../assets/images/business3.png';
import { motion } from "framer-motion";
import { FaStore, FaChartLine, FaGift } from "react-icons/fa";
import { useLanguage } from "../../contexts/LanguageContext";

const Business = () => {
  const { translations: t } = useLanguage();

  const features = [
    {
      icon: <FaStore className="business-feature-icon" />,
      image: Business1,
      title: t.business?.sellProducts?.title || "Seamlessly Showcase Your Products with iWinto",
      description: t.business?.sellProducts?.description || "Whether you’re running a shop or offering specialized services, iWinto lets you present your offerings directly to an active and engaged audience.",
      color: "#6366f1"
    },
    {
      icon: <FaChartLine className="business-feature-icon" />,
      image: Business2,
      title: t.business?.manageCMS?.title || "Resale Service",
      items: [
        t.business?.manageCMS?.items?.addProducts || "Share your products within a fresh marketplace where others assist in selling them faster"
      ],
      color: "#10b981"
    },
    {
      icon: <FaGift className="business-feature-icon" />,
      image: Business3,
      title: t.business?.rewardAudience?.title || "Cashback Service: 50–100%",
      description: t.business?.rewardAudience?.description || "A unique feature that refunds a portion of the amount you pay when purchasing products or services—turning every transaction into potential savings.",
      color: "#f59e0b"
    }
  ];

  return (
    <section className="business-section" id="business">
      <div className="gradient-bg"></div>
      
      <motion.div 
        className="business-header"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h1>{t.business?.header?.title || "Showcase Your Brand in a Distinctive Way"}</h1>
        <p>{t.business?.header?.subtitle || "Showcase Your Brand in a Distinctive Way Share your products and work with the community through a fresh, engaging approach. Leverage iWinto to spotlight your business directly and connect with your audience in meaningful ways."}
        </p>
      </motion.div>

      <div className="business-cards">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className="business-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <div className="card-decoration" style={{ backgroundColor: feature.color }}></div>
            <div className="business-image-container">
              <div className="business-image">
                <img src={feature.image} alt={feature.title} />
              </div>
              <div className="icon-wrapper" style={{ backgroundColor: feature.color }}>
                {feature.icon}
              </div>
            </div>
            <h3>{feature.title}</h3>
            {feature.description && <p>{feature.description}</p>}
            {feature.items && (
              <ul>
                {feature.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
            <motion.div 
              className="hover-underline"
              style={{ backgroundColor: feature.color }}
              initial={{ width: 0 }}
              whileHover={{ width: "100%" }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Business;